<template>
	<div
		v-if="!hide"
		class="landing-alert"
		:class="{ 'landing-alert_icon-bleed': iconBleed }"
		:style="{ backgroundColor: computedBackgroundColor, ...customStyles }"
	>
		<div v-if="icon" class="landing-alert__icon">
			<img :src="icon" alt="" />
		</div>

		<div class="landing-alert__text" v-html="text"></div>
	</div>
</template>

<script>
export default {
	name: 'LandingAlert',
	props: {
		text: {
			type: String,
			default: '',
		},

		icon: {
			type: String,
			default: null,
		},

		/**
		 * Render the icon oversized and flush with the banner's bottom edge instead of centering it
		 * in the row. For artwork that is meant to sit *on* the banner edge (a book standing in it)
		 * rather than float inside it — see Figma DEV-34801, node 216:2345.
		 */
		iconBleed: {
			type: Boolean,
			default: false,
		},

		backgroundColor: {
			type: String,
			default: null,
		},

		hide: {
			type: Boolean,
			default: false,
		},

		customStyles: {
			type: Object,
			default: () => ({}),
		},
	},

	computed: {
		computedBackgroundColor() {
			return this.backgroundColor
		},
	},
}
</script>

<style scoped lang="scss">
.landing-alert {
	display: flex;
	align-items: center;
	border-radius: var(--size-16);
	padding: var(--size-16) var(--size-20);
	margin-bottom: var(--size-16);
	font-size: var(--size-18);
	line-height: var(--size-22);
	font-weight: 600;
	gap: var(--size-20);

	&__icon {
		width: var(--size-56);
		flex-shrink: 0;
	}

	// Opt-in (`iconBleed`): artwork that sits on the banner's bottom edge instead of floating
	// centered in the row. Nothing changes for banners that don't pass the prop.
	&_icon-bleed {
		position: relative;
		overflow: hidden;

		.landing-alert__icon {
			// The artwork is taken out of flow below, so the box needs its own height — otherwise it
			// collapses and the banner loses the height the icon used to give it.
			height: var(--size-48);
		}

		.landing-alert__icon img {
			position: absolute;
			// Offsets resolve against the banner's padding box, so `bottom: 0` lands the artwork on
			// the banner edge whatever the vertical padding is. `left`/`right` stay auto so the icon
			// keeps its static column in the flex row.
			bottom: 0;
			width: var(--size-56);
			height: auto;
		}
	}
}
</style>
